/**
 * useVoiceActions
 * Component mount olduğunda action'ları registry'ye yazar, unmount'ta siler.
 * run()/getTarget() her zaman en güncel closure'a delege edilir (stale state önlenir).
 */
import { useEffect, useRef } from 'react';
import {
  registerVoiceAction,
  unregisterVoiceAction,
  type VoiceAction,
} from './voiceActions';

export function useVoiceActions(actions: VoiceAction[]): void {
  const ref = useRef(actions);
  ref.current = actions;

  // Sadece action id seti değişince yeniden kaydet.
  const ids = actions.map((a) => a.id).join(',');

  useEffect(() => {
    const current = ref.current;
    current.forEach((a) => {
      registerVoiceAction({
        id: a.id,
        description: a.description,
        destructive: a.destructive,
        params: a.params,
        run: (args) => {
          const live = ref.current.find((x) => x.id === a.id);
          return live ? live.run(args) : undefined;
        },
        getTarget: () => {
          const live = ref.current.find((x) => x.id === a.id);
          return live?.getTarget?.() ?? null;
        },
      });
    });
    return () => {
      current.forEach((a) => unregisterVoiceAction(a.id));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids]);
}
